import { theme as defaultTheme } from "@mindlercare/ui-web";
import { styled } from "styled-components";
import { ButtonProps } from "./messageModal.types";

export const SubHeading = styled.p`
  margin: 0 0 5px 0;
  font-weight: 500;
  color: ${defaultTheme.COLORS.DARK_GREEN};
  font-size: 12px;
`;

export const BodyText = styled.p`
  font-size: 16px;
  margin: 0;
  color: ${defaultTheme.COLORS.MEDIUM_GREY};
  opacity: 0.5;
  white-space: pre-wrap;
`;

export const TextAreaBody = styled.div`
  border: 1px solid ${defaultTheme.COLORS.MIDDLE_GREY};
  padding: 15px;
  border-radius: 8px;
  overflow-y: scroll;
  max-width: 436px;
  height: 200px;
  opacity: 0.5;
`;

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 48px;
  border: 1px solid ${defaultTheme.COLORS.MIDDLE_GREY};
  padding: 15px;
  border-radius: 8px;
  opacity: 0.5;
  margin-bottom: 24px;
`;

export const BottomContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;

  button:last-of-type {
    margin-left: 10px;
  }
`;

export const ActionButton = styled.button<ButtonProps>`
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  display: flex;
  padding: 0 40px;
  height: 40px;
  border: 1px solid ${({ theme }) => defaultTheme.COLORS.MIDDLE_GREY};
  font-family: ${({ theme }) => defaultTheme.FONT.FAMILY.BODY};
  font-weight: ${({ theme }) => defaultTheme.FONT.WEIGHT.MEDIUM};
  font-size: ${({ theme }) => defaultTheme.FONT.SIZE.SMALL_MEDIUM};
  border-radius: 20px;
  transition: 0.2s ease-in-out;
  color: ${({ variant, theme }) =>
    variant === "primary"
      ? defaultTheme.COLORS.WHITE
      : defaultTheme.COLORS.DARK_GREEN};
  background-color: ${({ variant, theme }) =>
    variant === "primary"
      ? defaultTheme.COLORS.MEDIUM_GREEN
      : defaultTheme.COLORS.WHITE};

  &:hover {
    background-color: ${({ variant, theme }) =>
      variant === "primary"
        ? defaultTheme.COLORS.GREEN_HOVER
        : defaultTheme.COLORS.MEDIUM_GREEN_OPACITY};
    transition: 0.3s ease-in-out;
    border: 1px solid ${({ theme }) => defaultTheme.COLORS.MEDIUM_GREEN};
  }
`;

export const GridContainer = styled.div`
  display: grid;
  gap: 24px;
`;

export const Counter = styled.span`
  margin-top: 4px;
  font-size: x-small;
`;
